export default __webpack_public_path__ + "static/media/icon_search.10c89fd2.svg";